module.exports = __webpack_public_path__ + "img/about-bg.9e0d785.svg";